// MUI
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
// LAYOUT BASED HOOK
import useLayout from '@/layouts/layout-1/context/useLayout';

// STYLED COMPONENT - Full width without Container constraints
const RootStyled = styled('div', {
  shouldForwardProp: prop => prop !== 'compact'
})(({
  theme,
  compact
}) => ({
  marginLeft: compact ? 86 : 280,
  transition: 'margin-left 0.3s ease-in-out',
  [theme.breakpoints.down(1200)]: {
    marginLeft: 0
  }
}));

export default function FullWidthBodyWrapper({
  children
}) {
  const {
    sidebarCompact
  } = useLayout();
  return (
    <RootStyled compact={sidebarCompact}>
      <Box sx={{ width: '100%', height: '100%' }}>
        {children}
      </Box>
    </RootStyled>
  );
}
